import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>(() => ({
  fpDeleteButton: {
    height: "31px",
  },
  deleteIcon: {
    width: "60px",
    height: "15px",
  },
}));

export const styles = {
  previewPaper: {
    maxHeight: `calc(100% - 5rem)`, // leave 5rem space for footer
    "&  img": {
      borderRadius: "5px",
      height: "100% !important",
      width: "100% !important",
      maxWidth: "768px",
      maxHeight: "420px",
    },
  },
  dialogContent: {
    padding: "16px !important",
    width: "500px",
    "& h4": {
      fontSize: "14px",
      fontWeight: "400",
    },
  },
  fpDeleteButton: {
    height: "34px !important",
  },
  deleteIcon: {
    width: "60px",
    height: "16px",
  },
  confirmBtnStyles: {
    width: "124px",
  },
  dismissBtnStyles: {
    width: "127px",
  },
};
